<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider
      v-model="collapsed"
      :trigger="null"
      collapsible
      style="overflow:auto;"
      class="sliderStyl"
    >
      <div class="logo">
        <img
          src="@/assets/ydLogo.png"
          alt=""
          style="width:32px;height:32px;margin-right:10px;"
        />
        <span v-if="!collapsed">征集管理系统</span>
      </div>
      <a-menu
        :theme="theme"
        mode="inline"
        :openKeys="tagMenuArr"
        @click="addTagsArr"
        :selectedKeys="tagsSelectArr"
        @openChange="changeMenu"
        class="menuClass"
      >
        <a-sub-menu v-for="item in nav" :key="item.id">
          <span slot="title">
            <a-icon :type="item.icon" /><span>{{ item.name }}</span></span
          >
          <template v-for="items in item.children">
            <a-menu-item v-if="items.url" :key="items.id">
              <router-link :to="items.url">
                {{ items.name }}
              </router-link>
            </a-menu-item>
            <a-sub-menu
              style="padding-left:-8px"
              v-if="!items.url"
              :key="items.id"
              :title="items.name"
            >
              <a-menu-item v-for="itemTs in items.children" :key="itemTs.id">
                <router-link :to="itemTs.url">
                  {{ itemTs.name }}
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </a-sub-menu>
      </a-menu>
    </a-layout-sider>
    <a-layout style="height:100vh; overflow:auto;">
      <a-layout-header class="a_header" style="background: #fff; padding: 0">
        <!-- <a-switch
          default-checked
          checked-children="dark"
          un-checked-children="light"
          @change="changeTheme"
        /> -->
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        />

        <div class="user_name">
          <img
            :src="headUrl"
            style="width: 20px;height: 20px;"
            v-if="headUrl"
          />
          <img
            src="../assets/logo.png"
            style="width: 20px;height: 20px"
            v-if="!headUrl"
          />
          <a-dropdown :trigger="['click']">
            <div style="margin-left: 5px">{{ userName }}</div>
          </a-dropdown>
        </div>
        <div style="display: flex;align-items: center">
          <a-tooltip placement="bottom">
            <template slot="title">
              <span>退出登陆</span>
            </template>
            <a-icon
              type="poweroff"
              @click="quitLogin"
              class="trigger"
              style="display: flex;align-items: center;padding:0 20px"
            />
          </a-tooltip>
        </div>
      </a-layout-header>
      <TagsView
        :tagsSelectArr="tagsSelectArr"
        @tagsRightClick="tagsRightClick"
      ></TagsView>
      <div
        style="width: 100%;height: 100vh;z-index: 100;position: fixed"
        v-show="isvisible"
        @click="closeModal"
      >
        <ul
          :style="{ left: left + 'px', top: top + 'px', 'z-index': 101 }"
          class="contextmenu"
        >
          <li @click.stop="closeVisible">全部删除</li>
        </ul>
      </div>

      <a-layout-content
        class="a_content"
        :style="{
          margin: '24px 16px',
          padding: '24px',
          background: '#fff',
          minHeight: '280px'
        }"
      >
        <!-- <HelloWorld v-if="selectedKey == 10" /> -->
        <router-view id="content_main"></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import { DownOutlined } from "@ant-design/icons-vue";themeColor
import { removeStorage, getStorage } from "@/utils/auth";
import { quitLogin } from "@/request/api.js";
import TagsView from "@/components/tagsView.vue";
export default {
  components: {
    // HelloWorld,
    // DownOutlined
    TagsView
  },
  data() {
    return {
      collapsed: false,
      isvisible: false,
      left: 0,
      top: 0,
      theme: "dark",
      nav: [],
      userItem: null,
      userName: "",
      headUrl: "",
      tagsSelectArr: [],
      tagMenuArr: [],
      isHaveItem: true,
      visible: false
    };
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        // console.log(val, oldVal, "新旧");
        if (val) {
          let a = false;
          let b = false;
          this.nav.map(item => {
            if (
              item.children.filter(items => items.url == val.path).length != 0
            ) {
              a = true;
            }
            if (!a) {
              item.children.map(res => {
                if (
                  res.children &&
                  res.children.filter(re => re.url == val.path).length != 0
                ) {
                  b = true;
                }
              });
            }
          });
          if (!a && !b) {
            // console.log(a, b, "嘿嘿");
            let tagsid = null;
            this.nav.forEach(item => {
              item.children.forEach(items => {
                if (items.url == oldVal.path) {
                  tagsid = items.id;
                  this.tagMenuArr[0] = item.id;
                } else {
                  if (items.children && items.children.length != 0) {
                    items.children.forEach(res => {
                      if (res.url == oldVal.path) {
                        tagsid = res.id;
                        this.tagMenuArr[0] = item.id;
                      }
                    });
                  }
                }
              });
            });
            this.tagsSelectArr[0] = Number(tagsid);
          } else {
            let tagsid = null;
            this.nav.forEach(item => {
              // console.log(item.children, "item");
              item.children.forEach(items => {
                if (items.url == val.path) {
                  tagsid = items.id;
                  this.tagMenuArr[0] = item.id;
                } else {
                  // console.log(items.children, "item");
                  if (items.children && items.children.length != 0) {
                    items.children.forEach(res => {
                      if (res.url == val.path) {
                        tagsid = res.id;
                        this.tagMenuArr[0] = item.id;
                      }
                    });
                  }
                }
              });
            });
            this.tagsSelectArr[0] = Number(tagsid);
          }
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    tagsRightClick(e) {
      // console.log(e, "hahahheihei");
      this.isvisible = e[2];
      this.left = e[0];
      this.top = e[1];
    },
    closeModal() {
      this.isvisible = false;
    },
    closeVisible() {
      let arr = [this.$store.state.tags.tagsArr[0]];
      this.$store.commit("CHANGE_TAGS_ARR", arr);
      this.isvisible = false;
      this.$router.push(this.$store.state.tags.tagsArr[0].url);
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    changeMenuArr(path) {
      this.nav.map(item => {
        if (item.children.length != 0) {
          item.children.map(items => {
            if (items.url == path) {
              this.tagMenuArr[0] = item.id;
            } else {
              if (items.children) {
                items.children.map(res => {
                  if (items.children.length != 0) {
                    if (res.url == path) {
                      this.tagMenuArr[0] = item.id;
                    }
                  }
                });
              }
            }
          });
        }
      });
    },
    changeMenu(openKeys) {
      const latestOpenKey = openKeys.find(
        key => this.tagMenuArr.indexOf(key) === -1
      );
      if (this.nav.filter(item => item["id"] == latestOpenKey).length == 0) {
        this.tagMenuArr = openKeys;
      } else {
        this.tagMenuArr = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    addTagsArr(e) {
      // console.log(e, "hahahhahhahah");
      if (
        this.$store.state.tags.tagsArr.filter(item => item["id"] == e.key)
          .length == 0
      ) {
        let tags = null;
        this.nav.forEach(item => {
          item.children.forEach(items => {
            if (items.id == e.key) {
              tags = items;
            } else {
              if (items.children && items.children.length > 0) {
                items.children.forEach(res => {
                  if (res.id == e.key) {
                    tags = res;
                  }
                });
              }
            }
          });
        });
        this.$store.commit("CHANGE_TAGS_ITEM", tags);
      }
    },
    async getUserInfo() {
      // let res = await getUserInfo();
      // // console.log(res);
      // this.userItem = res.data;
      // this.userName = res.data.username;
      // this.headUrl = res.data.headUrl;
    },
    async quitLogin() {
      let res = await quitLogin();
      // console.log(res);
      if (res.stateCode == 101) {
        removeStorage("token");
        removeStorage("tagsArr");
        location.reload();
      }
    }
    // changeTheme(checked) {
    //   this.theme = checked ? "dark" : "light";
    // }
    // turn() {
    //   this.$router.replace({
    //     path: "/empty", //跳转空白页，利用空白页刷新
    //     name: "Empty"
    //   });
    // }
  },
  created() {
    const routerList = this.$store.getters.addRouters;
    const rolesUser = getStorage("roles");
    routerList.map(item => {
      if (item.roles) {
        const status = item.roles.some(item => item === rolesUser);
        if (status && item.children) {
          const childArr = JSON.parse(JSON.stringify(item.children));
          const childArr2 = childArr.filter(items =>
            items.roles.some(i => i === rolesUser)
          );
          item.children = childArr2;
        }
        if (status) {
          this.nav.push(item);
        }
      } else {
        if (item.children) {
          const childArr = JSON.parse(JSON.stringify(item.children));
          const childArr2 = childArr.filter(items =>
            items.roles.some(i => i === rolesUser)
          );
          item.children = childArr2;
        }
        this.nav.push(item);
      }
    });
    console.log(this.nav, "000000");
    this.tagsSelectArr[0] = this.$store.state.tags.tagsArr[0].id;
    // if (this.$store.getters.roles) {
    //   this.nav = this.$store.getters.roles;
    //   console.log(this.nav, "11111111111111");
    //   this.changeMenuArr(this.$route.path);
    // }
    this.changeMenuArr(this.$route.path);
    let a = false;
    let b = false;
    this.nav.map(item => {
      if (
        item.children.filter(items => items.url == this.$route.path).length != 0
      ) {
        a = true;
      }
      if (!a) {
        item.children.map(res => {
          if (
            res.children &&
            res.children.filter(re => re.url == this.$route.path).length != 0
          ) {
            b = true;
          }
        });
      }
    });
    if (!a && !b) {
      let old = getStorage("oldval");
      this.changeMenuArr(old);
      this.$store.state.tags.tagsArr.map(item => {
        if (old == item.url) {
          this.tagsSelectArr[0] = item.id;
        }
      });
    } else {
      this.$store.state.tags.tagsArr.map(item => {
        if (this.$route.path == item.url) {
          this.tagsSelectArr[0] = item.id;
        }
      });
    }
  }
};
</script>
<style lang="scss">
#components-layout-demo-custom-trigger {
  height: 100%;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.sliderStyl {
  &::-webkit-scrollbar {
    display: none;
  }
}

/*#components-layout-demo-custom-trigger .trigger:hover {*/
/*  color: */
/*}*/

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  // background: rgba(255, 255, 255, 0.2);
  margin: 16px;
  color: #fff;
  line-height: 32px;
}
.ant-layout-sider {
  flex: 0 0 240px !important;
  max-width: 240px !important;
  min-width: 240px !important;
  width: 240px !important;
}
.ant-layout-sider-collapsed {
  flex: 0 0 80px !important;
  max-width: 80px !important;
  min-width: 80px !important;
  width: 80px !important;
}
.ant-tabs-bar {
  margin: 0 !important;
}
.warpper_content {
  position: relative !important;
}
.nav_live {
  position: sticky !important;
  top: 0 !important;
  z-index: 1005 !important;
  background: #ffffff !important;
}
.warpper_table {
  position: relative;
}
.title_live {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
}
.ant-menu-item,
.ant-menu-item-selected {
  padding: 0 !important;
}
.a_header {
  display: flex;
  .user_name {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0 0 26px;
  }
}
.a_content {
  flex: 1;
  display: flex;
  margin: 0 !important;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  text-align: left;
}
.ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-item-group-title,
.ant-menu-dark .ant-menu-item > a {
  padding-left: 40px;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  padding-left: 40px !important;
}
.ul-li {
  width: 20px;
  height: 20px;
  margin: 10px 8px;
  list-style: none;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background-color: #fafafa;
  color: black;
}
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  max-width: 100% !important;
  max-height: 100% !important;
  width: auto !important;
  height: auto !important;
}
</style>
